import { render, staticRenderFns } from "./ElderlyInsSigning3.vue?vue&type=template&id=265a3e18&scoped=true&"
import script from "./ElderlyInsSigning3.vue?vue&type=script&lang=js&"
export * from "./ElderlyInsSigning3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265a3e18",
  null
  
)

export default component.exports